import { isMobile } from '../utils'

export const IS_MOBILE = isMobile()
